import React from "react";
import {FaDiscord} from  "react-icons/fa"
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillYoutube
} from "react-icons/ai";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={9} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body"><b className="purple">I am an advanced astronomy discord bot providing you with over 25 commands, with each track of what's happening in space!</b>
              <br />My purpose is to educate people about the universe and its secrets. Space is the greatest mystery right now, thus it's never too late to understand it.
              <br />
            </p>
          </Col>

          <Col md={10} className="home-about-description">
            <h1 style={{ textAlign: "justify", fontSize: "2em" }}>
            DETAILS:  </h1>
            <p style={{ textAlign: "justify" }}>
            <br />Developer:<span className="purple"> R2#8184 (astro_solutions)</span>
            <br />Started project on:<span className="purple"> Tuesday, February 15, 2022</span>
            <br />Programming language:<span className="purple"> Python (3.9)</span>
            <br />Discord client API libary:<span className="purple"> Nextcord</span>
            <br />Average response latency:<span className="purple"> 106 ms</span>
          </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
          <br /><br /><br />
            <p>
              Feel free to <span className="purple">connect </span>with us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://discord.gg/XX9p5qUkuj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/sotkrist"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
              <a
                href="https://www.youtube.com/channel/UCvgWKK9iDc4drrBLDpSehhA"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <  AiFillYoutube />
              </a>
              </li>
            </ul>
          </Col>
          <Col md={8} className="home-about-description">
            <h1 style={{textAlign: "left", fontSize: "1em" }}>
              Cosmos version: <span className="purple">4.4.1</span>
              <br />
              Website version: <span className="purple">1.8.0</span>
            </h1>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
